import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../firebase";

// Function to fetch geo location data from Firebase partner data
export const fetchPhotoGeoLocation = async (userId, photoId, otherUserId = null) => {
  let photoDoc = await getDoc(doc(db, `users/${userId}/photos/${photoId}`));
  if (photoDoc.exists()) {
    return photoDoc.data();
  }

  // If the photo does not exist in the current user's collection, check another user's collection
  if (otherUserId) {
    photoDoc = await getDoc(doc(db, `users/${otherUserId}/photos/${photoId}`));
    if (photoDoc.exists()) {
      return photoDoc.data();
    }
  }

  return null;
};

// Function to extract geo data from Google Photos Picker media item
export const extractGeoDataFromMediaItem = async (mediaItem, otherUserId = null) => {
  const user = auth.currentUser;
  if (!user) return { latitude: null, longitude: null };

  let latitude = null;
  let longitude = null;

  // First try to get geo data from the media metadata if available
  if (mediaItem.mediaFile?.mediaFileMetadata?.location) {
    latitude = mediaItem.mediaFile.mediaFileMetadata.location.latitude;
    longitude = mediaItem.mediaFile.mediaFileMetadata.location.longitude;
  }

  // If no geo data in metadata, try to fetch from Firebase partner data using filename
  if (!latitude || !longitude) {
    const userId = user.uid;
    const filename = mediaItem.mediaFile?.filename || mediaItem.filename;
    
    if (filename) {
      const photoGeoData = await fetchPhotoGeoLocation(userId, filename, otherUserId);
      if (photoGeoData) {
        latitude = photoGeoData.latitude;
        longitude = photoGeoData.longitude;
      }
    }
  }

  return { latitude, longitude };
}; 